import React from 'react';
import { useTheme } from '@mui/material/styles';
import useNotificationStyles from './NotificationStyles';

const NotificationLegend = () => {
  const styles = useNotificationStyles();
  const theme = useTheme();

  return (
    <styles.LegendContainer>
      <styles.LegendTitle>Notification Types</styles.LegendTitle>
      <styles.LegendItem>
        <styles.LegendColor color={theme.palette.notifications.main} />
        <styles.LegendText>System</styles.LegendText>
      </styles.LegendItem>
      <styles.LegendItem>
        <styles.LegendColor color={theme.palette.notifications.observation} />
        <styles.LegendText>Observation</styles.LegendText>
      </styles.LegendItem>
      <styles.LegendItem>
        <styles.LegendColor color={theme.palette.notifications.leak} />
        <styles.LegendText>Leak</styles.LegendText>
      </styles.LegendItem>
    </styles.LegendContainer>
  );
};

export default NotificationLegend;